import {MaintainAppConfig} from '@hconnect/common/hproduce/maintain.types'

export const rcfa: MaintainAppConfig = {
  name: 'Maintain',
  displayName: 'RCFA',
  whiteListedPermissionTypes: ['CONTRIBUTE_TO_ROOT_CAUSE_FAILURE_ANALYSES']
}
